import { useTheme } from "@emotion/react";
import { Box, styled } from "@mui/material";
import ReactApexChart from "react-apexcharts";

export default function ChartProofWork({ coins }) {
  const theme = useTheme();

  const series = coins?.map((coin) => coin?.percent);

  const options = {
    theme: {
      palette: "palette1",
      monochrome: {
        enabled: false,
        shadeTo: "dark",
        shadeIntensity: 0.55,
      },
    },
    stroke: {
      show: false,
    },
    tooltip: {
      enabled: true,
      custom: function ({ seriesIndex, w }) {
        return `<div>
                <span style="padding:5px;">
                ${w.globals.labels[seriesIndex]}
                </span>
            </div>`;
      },
    },
    labels: coins?.map((coin) => coin?.name),
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: 'left',
      offsetY: 0,
      offsetX: -10,
      itemMargin: {
        vertical: 1,
      },
      formatter: function (seriesName, opts) {
        return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%";
      },

      labels: {
        colors: [theme.palette.common.white],
        useSeriesColors: false,
      },

      onItemClick: {
        toggleDataSeries: true,
      },
    },
    chart: {
      type: "donut",
      background: undefined,
    },
    plotOptions: {
      pie: {
        customScale: 0.7,

        labels: {
          enabled: true,
          formatter: function (val) {
            return val + "%";
          },
        },
        expandOnClick: true,
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "10px",
              fontWeight: 700,
              color: theme.palette.common.white,
              offsetY: -10,
              formatter: function (val) {
                return val;
              },
            },
            value: {
              show: true,
              fontSize: "14px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: theme.palette.common.white,
              offsetY: 2,
              formatter: function (val) {
                return [val + "%"];
              },
            },
          },
        },
      },
    },
  };

  return (
    <ChartWrapper>
      <ReactApexChart options={options} series={series} type="donut" height={200} />
    </ChartWrapper>
  );
}

const ChartWrapper = styled(Box)(({ theme }) => ({
  '.apexcharts-legend-text': {
    color: `${theme.palette.text.main} !important`
  },
  '.apexcharts-text': {
    fill: `${theme.palette.text.main} !important`
  }
}))
